const ActionTypes = {
  GET_DBVERSION: '[Application] Get Database Info Options',
  GET_DBVERSION_SUCCESS: '[Application] Get Database Info Success',
  GET_DBVERSION_FAIL: '[Application] Get Database Info Fail',

  GET_DBVERSIONS: '[Application] Get Database Versions',
  GET_DBVERSIONS_SUCCESS: '[Application] Get Database Versions Success',
  GET_DBVERSIONS_FAIL: '[Application] Get Database Versions Fail',
}

export class GetLatestDbVersion {
  static type = ActionTypes.GET_DBVERSION;
}

export class GetLatestDbVersionSuccess {
  static type = ActionTypes.GET_DBVERSION_SUCCESS;

  constructor(public payload: {content: string, warning: string}) {}
}

export class GetLatestDbVersionFail {
  static type = ActionTypes.GET_DBVERSION_FAIL;
}

export class GetDbVersions {
  static type = ActionTypes.GET_DBVERSIONS;
}
export class GetDbVersionsSuccess {
  static type = ActionTypes.GET_DBVERSIONS_SUCCESS;

  constructor(public payload: {content: string[]}) {}
}
export class GetDbVersionsFail {
  static type = ActionTypes.GET_DBVERSIONS_FAIL;
}